import { Form } from "@unform/web";
import { useEffect, useRef, useState } from "react";

import AdminRoutes from "Routes/Components/Admin";

import { cpfcnpjMask } from "Helpers/Format";

import { UsePaginatedFetch } from "Hooks/UsePaginatedFetch";

import Button from "Components/Admin/Buttons";
import Input from "Components/Admin/Form/Input";
import Loading from "Components/Admin/Loading";
import Section from "Components/Admin/Section";
import Table from "Components/Admin/Table";
import { TableActionLink, withRowLink } from "Components/Admin/TableRowLink";

import { columns, downloadColumns } from "./columns";
import * as S from "./styles";

const LINK_TITLE = "Abrir usuário — Ctrl/Cmd+clique para nova aba";

const detailPath = (row) =>
  row.id ? AdminRoutes.UpdateUsers.path.replace(":id", row.id) : null;

const ListUsers = () => {
  const [formData, setFormData] = useState({});

  const [userDocument, setUserDocument] = useState("");

  const cancelRequest = useRef(false);

  const {
    setStartFetch,
    progress,
    requestInProgress,
    firstResponseReceived,
    data,
  } = UsePaginatedFetch({
    method: "post",
    path: "/users/list-users",
    body: { filters: { ...formData } },
    responseAccessor: "users",
    pageSize: 1000,
    cancelRequest: cancelRequest,
  });

  useEffect(() => {
    // Carregar dados automaticamente ao abrir a tela
    if (!requestInProgress && !firstResponseReceived) {
      setStartFetch(true);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Section>
      <S.SectionWrapper>
        <S.Wrapper>
          <Form
            onSubmit={
              !requestInProgress
                ? (data) => {
                    setFormData(data);
                    setStartFetch(true);
                  }
                : null
            }
          >
            <Input
              name="external_id"
              label="ID do Participante"
              placeholder="ID"
              type="text"
            />

            <Input
              name="full_name"
              label="Nome do Participante"
              placeholder="Nome"
              type="text"
            />

            <Input
              name="document"
              label="CPF do Participante"
              placeholder="CPF"
              type="text"
              onChange={({ target }) => {
                setUserDocument(cpfcnpjMask(target.value));
              }}
              value={userDocument}
            />

            <Button
              type="submit"
              text={
                requestInProgress
                  ? progress
                    ? `Carregando ${progress}%...`
                    : "Carregando..."
                  : "Buscar"
              }
            />
            {requestInProgress && (
              <Button
                text="Cancelar requisição"
                variant="critical"
                onClick={() => {
                  cancelRequest.current = true;
                }}
              />
            )}
          </Form>

          {requestInProgress && !firstResponseReceived ? (
            <Loading />
          ) : (
            <Table
              name="Usuários"
              data={data}
              columns={[
                ...withRowLink(columns, {
                  accessor: "full_name",
                  to: detailPath,
                }),
                {
                  Header: "Ações",
                  accessor: "actions",
                  noSearch: true,
                  width: "70px",
                  Cell: ({ cell }) => (
                    <TableActionLink
                      to={detailPath(cell.row.original)}
                      title={LINK_TITLE}
                    />
                  ),
                },
              ]}
              downloadColumns={downloadColumns}
              disableDownloadButton={requestInProgress}
            />
          )}
        </S.Wrapper>
      </S.SectionWrapper>
    </Section>
  );
};

export default ListUsers;
